export default "__VITE_PUBLIC_ASSET__536a413e__"